import mock from "./mock";

import "./db/auth-db";
import "./db/rooms-db";

mock.onAny().passThrough();